export function DownArrow() {
	return (
		<svg
			viewBox="0 0 32 32"
			data-testid="arrow-down"
			aria-hidden="true"
			focusable="false"
			role="img"
      width={16}
      height={16}
		>
			<title>Arrow Down</title>
			<path
        fill="#1F4494"
				stroke="none"
				d="M24.39,16.38a2,2,0,0,0-2.94,0L18,20V7a2,2,0,0,0-4,0V20l-3.45-3.62a2,2,0,0,0-2.94,0,2.16,2.16,0,0,0,0,3l6.86,7a2.2,2.2,0,0,0,3.06,0l6.86-7A2.16,2.16,0,0,0,24.39,16.38Z"
			></path>
		</svg>
	);
}
